import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "../../UserDomainList/DomainLogindetail.css";
import { Link, useParams } from "react-router-dom";
import Select from 'react-select';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import isURL from 'validator/lib/isURL';
import { useDispatch } from "react-redux";
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { AppContext } from "../../../../Context/Context";
import CommonAlert from "../../../../Commonalert/commonalert";
import { customDropdownStyles } from "../../../../Commonalert/commonDropdown";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";
import Loader from "../../CommonLoader";
import CommonBreadCrumb from "../../../../Commonalert/commonbreadcrumb";
import { timezoneval } from "../../Commonfun";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Rightsidebar from "../../Rightsidebar/Rightsidebar";
import UserActivityTracker from "../../../../hooks/userActivityTracker";


function SecurityAuditSettings(props) {
    const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);

    const [secureType, setSecureType] = useState("")
    const [domainUrl, setDomainUrl] = useState("")
    const [gitRepo, setGitRepo] = useState("")
    const [dockerHub, setDockerHub] = useState("")
    const [onUsername, SetonUsername] = useState("")
    const [onPassword, SetonPassword] = useState("")

    const [prevSecureType, setPrevSecureType] = useState("")
    const [prevDomainUrl, setPrevDomainUrl] = useState("")
    const [prevGitRepo, setPrevGitRepo] = useState("")
    const [prevDockerHub, setPrevDockerHub] = useState("")
    const [prevOnUsername, SetPrevonUsername] = useState("")
    const [prevOnPassword, SetPrevonPassword] = useState("")

    const [domainurlError, setDomainUrlError] = useState("")
    const [gitRepoError, setGitRepoError] = useState("")
    const [dockerHubError, setDockerHubError] = useState("")
    const [onUserError, SetonUserError] = useState("")

    const [secureTypeError, setSecureTypeError] = useState("")

    const [onPasswordError, SetonPasswordError] = useState("")
    const [onPageError, SetonPageError] = useState("")
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [apiopen, setapiOpen] = React.useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const [showPassword, setShowPassword] = useState(false);
    const [openCommonAlerts, setOpenCommonAlerts] = useState(false);

    const [selectedWeekReport, setWeekReport] = useState(null);
    const [prevSelectedWeekReport, setPrevWeekReport] = useState(null);
    const [weekReportOptions, setWeekReportOptions] = useState([
        { label: 'Yes', value: true },
        { label: 'No', value: false }
    ]);
    const [weekReportError, setWeekReportError] = useState(null);
    const [isFetchedData, setIsFetchedData] = useState(false);
    const [fetchedDataId, setFetchedDataId] = useState('');
    const [successApiOpen, setSuccessApiOpen] = useState(false);
    const [successApiMsg, setSuccessApiMsg] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);

    const esodata = useSelector((state) => state);
    const ApiToken = esodata.apiauthkey.value
    const navigate = useNavigate();

    //faq
    const [faqData, setfaqData] = useState("2")
    const [toggle, setToggle] = useState(false);
    const [initialfaqDateval, SetInitialfaqDateval] = useState([]);


    useEffect(() => {
        fetchSecurityAudit();
        faqdatafun();
    }, []);

    const fetchSecurityAudit = () => {
        setLoading(true);
        // axios.get(`${process.env.REACT_APP_API_URL}security_tools/save_security_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&id=1&formats=&timezone=${timezoneval()}`, {
        axios.get(`${process.env.REACT_APP_API_URL}security_tools/save_security_audit/?user_domain_id=${esodata.domaindata.value.header_selected}`, {
            headers: {
                Authorization: `${ApiToken}`,
            }
        }).then(response => {
            console.log('data', response);
            if (response?.data) {
                //                 setPrevDomainUrl(domainUrl);
                // setPrevDockerHub(dockerHub);
                // setPrevGitRepo(gitRepo);
                // setPrevSecureType(secureType);
                // setPrevWeekReport(selectedWeekReport);
                // SetPrevonUsername(onUsername);
                // SetPrevonPassword(onPassword);

                // setSecurityAuditData(response.data);
                if (response?.data?.id) {
                    setIsFetchedData(true);
                    setFetchedDataId(response?.data?.id);
                }
                setDomainUrl(response.data.domain_url);
                setDockerHub(response.data.docker_url);
                setPrevDomainUrl(response.data.domain_url);
                setPrevDockerHub(response.data.docker_url);
                if (response.data.weekly_report) {
                    setWeekReport({
                        label: 'Yes',
                        value: response.data.weekly_report
                    });
                    setPrevWeekReport({
                        label: 'Yes',
                        value: response.data.weekly_report
                    });
                } else {
                    setWeekReport({
                        label: 'No',
                        value: response.data.weekly_report
                    });
                    setPrevWeekReport({
                        label: 'No',
                        value: response.data.weekly_report
                    });

                }

                if (!response.data.git_type) {
                    setSecureType('none');
                } else {
                    setSecureType(response.data.git_type);
                }
                setGitRepo(response.data.git_url);
                setPrevSecureType(response.data.git_type);
                setPrevGitRepo(response.data.git_url);
                if (response.data.git_type === 'private') {
                    SetonUsername(response.data.git_username);
                    SetonPassword(response.data.git_password);
                    SetPrevonUsername(response.data.git_username);
                    SetPrevonPassword(response.data.git_password);
                }
            }
        }).catch(error => {
            if (
                error?.response?.status == 599 ||
                error?.response?.status == 400 ||
                error?.response?.status == 500
            ) {
                setapiOpen(true);
                setapierrorMsg(error?.response?.data?.error);
            } else if (
                error?.code == "ERR_NETWORK" ||
                error?.response?.status == 404
            ) {
                navigate("/errorpages");
            }
        })

        setLoading(false);
    }

    const onOptionChange = e => {
        setSecureType(e.target.value)
        if (e.target.value === "public" || e.target.value === "none") {
            SetonUsername("");
            SetonPassword("");
        }
    }
    const onDomainUrl = e => {
        setDomainUrl(e.target.value)
    }
    const onGitRepo = e => {
        setGitRepo(e.target.value)
    }
    const onDockerHub = e => {
        setDockerHub(e.target.value)
    }

    const onDomainUrlChange = e => {
        SetonUsername(e.target.value)
    }
    const onpasswordChange = e => {
        SetonPassword(e.target.value)
    }

    const handleReset = () => {
        setSecureType(prevSecureType);
        setDomainUrl(prevDomainUrl);
        setDockerHub(prevDockerHub);
        SetonUsername(prevOnUsername);
        SetonPassword(prevOnPassword);
        setGitRepo(prevGitRepo);
        setWeekReport(prevSelectedWeekReport);
    }
    const finalreportNow = async () => {
        SetonPageError("")
        setDomainUrlError("")
        setGitRepoError("")
        setDockerHubError("")
        SetonUserError("")
        SetonPasswordError("")
        setSecureTypeError("")
        setLoading(true);
        var data_val = 1;
        // if (domainUrl === "") {
        //     setDomainUrlError("Enter Domain URL")
        //     data_val = 2;
        // }
        if (domainUrl !== "") {
            if (!isURL(domainUrl)) {
                setDomainUrlError("Enter Valid Domain URL")
                data_val = 2;
            }
        }
        // if (gitRepo === "") {
        //     setGitRepoError("Enter Git Repository")
        //     data_val = 2;
        // }

        if (secureType === "") {
            setSecureTypeError("Select Git Type")
            data_val = 2;
        }

        // if (dockerHub === "") {
        //     setDockerHubError("Enter the DockerHub")
        //     data_val = 2;
        // }
        if (dockerHub !== "") {
            if (!isURL(dockerHub)) {
                setDockerHubError("Enter Valid DockerHub")
                data_val = 2;
            }
        }
        if (secureType === "yes") {
            if (onUsername === "") {
                SetonUserError("Please enter a Username")
            }
            if (onPassword === "") {
                SetonPasswordError("Please enter a password")
            }
        }
        if (!selectedWeekReport) {
            setWeekReportError("Please select search weekreport");
            data_val = 2;
        }
        if (data_val === 2) {
            setLoading(false);

            return false;
        }
        else {
            try {
                setLoading(true);
                const gitType = secureType === 'none' ? '' : secureType;
                var sendData = {
                    user_domain_id: esodata.domaindata.value.header_selected,
                    domain_url: domainUrl,
                    docker_url: dockerHub,
                    git_url: gitRepo,
                    git_type: gitType, //private, //“public”
                    // git_username: onUsername,
                    // git_password: onPassword,
                    weekly_report: selectedWeekReport?.value
                };
                if (isFetchedData && fetchedDataId) {
                    sendData['id'] = fetchedDataId;
                }
                if (secureType === 'private') {
                    sendData['git_username'] = onUsername;
                    sendData['git_password'] = onPassword;
                }
                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL}security_tools/${isFetchedData ? 'update_security_audit' : 'save_security_audit'}/`,
                    sendData,
                    {
                        headers: {
                            Authorization: `${ApiToken}`,
                        },
                    }
                ).catch((error) => {
                    setLoading(false)
                    console.log(error)
                    if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                        setapiOpen(true);
                        setapierrorMsg(error?.response?.data?.error)
                    }
                    else if (error?.code == "ERR_NETWORK") {
                        navigate('/errorpages')
                    }
                });
                console.log(response, 'response');
                if (response?.status == 200) {
                    setPrevDomainUrl(domainUrl);
                    setPrevDockerHub(dockerHub);
                    setPrevGitRepo(gitRepo);
                    setPrevSecureType(secureType);
                    setPrevWeekReport(selectedWeekReport);
                    SetPrevonUsername(onUsername);
                    SetPrevonPassword(onPassword);

                    setIsFetchedData(true);
                    setSuccessApiOpen(true);
                    setIsOpen(false);
                    setSuccessApiMsg(response?.data?.message);
                    fetchSecurityAudit();
                }
            } catch (err) {
                setLoading(false);
                console.log(err)
                SetonPageError(err?.response?.data?.error)
            }
        }
        setLoading(false);

    }

    const apihandleClose = () => {
        setapiOpen(false);
    };

    const successPopupClose = () => {
        setSuccessApiOpen(false);
    };

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    function closeModal() {
        setSecureType(prevSecureType);
        setDomainUrl(prevDomainUrl);
        setDockerHub(prevDockerHub);
        SetonUsername(prevOnUsername);
        SetonPassword(prevOnPassword);
        setGitRepo(prevGitRepo);
        setWeekReport(prevSelectedWeekReport);
        setIsOpen(false);
    }

    function openModel() {
        setIsOpen(true);
    }

    const handleToggle = () => {
        if (faqData != 1) {
            setfaqData(1)
        }
        else {
            setfaqData(2)
        }
        setToggle((pre) => !pre);
    };

    const faqdatafun = async (menubutval = "") => {
        var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=76`

        try {
            const doaminsectiondatavalue = await axios.get(
                datavar,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });
            if (doaminsectiondatavalue?.data) {
                SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
            }
        } catch (err) { }
    }


    return (
        <><ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Security Audit Settings</title>
            </Helmet>
            {loading === true ? <Loader /> : null}
            <div className={`over_all_container over_all_accessibility ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
                <Container maxWidth={false} className="dashboard-container">
                    <Box className="dashboard-box">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={4}>
                                <div>
                                    <h1 className="dashboard_header">
                                        Security Audit Settings
                                        <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                                    </h1>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <div className="top_breadcrumb_menu">
                                    <div className="exportpdf_outer">
                                        <div className="breadcrumb-wrapper">
                                            <CommonBreadCrumb breadcrumbValue={[
                                                { title: 'Settings', active: true },
                                                { title: 'Security Audit Settings', active: true }
                                            ]} />
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="dashboard-card-container">
                    <Box className="dashboard-box-card">
                        <Grid container className="dashboard-card-grid">
                            <Grid item xs={12} md={12}>
                                <div className="">
                                    <div className="color-checker-container" style={{ maxWidth: "650px" }}>
                                        <div style={{ marginBottom: '20px', color: "#f05959", display: 'flex', gap: '10px' }}>
                                            <div>Note: You need to whitelist the IPs (44.240.233.25, 35.82.149.10) to access your private Git repository for accurate reporting.</div>
                                            <button type="button" className="keyword-submit" onClick={openModel}>{isFetchedData ? 'Update' : 'Create'}</button>
                                        </div>
                                        <form className="frm_container">
                                            <table className="table">
                                                <col style={{ width: "50%" }} />
                                                <col style={{ width: "50%" }} />
                                                <tbody>
                                                    <tr>
                                                        <td className="table-label" style={{ fontWeight: 800 }}>Domain URL :</td>
                                                        <td>{domainUrl || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-label" style={{ fontWeight: 800 }}>Docker Hub URL : </td>
                                                        <td style={{ wordBreak: "break-all" }}>{dockerHub || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-label" style={{ fontWeight: 800 }}>Weekly Report : </td>
                                                        <td>
                                                            {selectedWeekReport?.label || '-'}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="table-label" style={{ fontWeight: 800 }}>Git Type : </td>
                                                        <td>
                                                            {secureType}

                                                        </td>
                                                    </tr>
                                                    {secureType === "private" &&
                                                        <>                                                                            <tr>
                                                            <td className="table-label" style={{ fontWeight: 800 }}>Username : </td>
                                                            <td>
                                                                {onUsername || '-'}

                                                            </td>
                                                        </tr>
                                                            <tr>
                                                                <td className="table-label" style={{ fontWeight: 800 }}>Password : </td>
                                                                <td>
                                                                    {onPassword ? '********' : '-'}

                                                                </td>
                                                            </tr>
                                                        </>
                                                    }
                                                    <tr>
                                                        <td className="table-label" style={{ fontWeight: 800 }}>Git Repository URL : </td>
                                                        <td style={{ wordBreak: "break-all" }}>{gitRepo || '-'}</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </form>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="footer-container">
                    <Box className="footer-box">
                        <Grid container className="footer-grid">
                            <Grid item xs={12} md={6}>
                                <div className="footer-left">
                                    <p className="footer-text">
                                        All Rights Reserved Copyright © 2026 |
                                        <a href="https://www.egrovesys.com/" target="blank">
                                            <span className="footer-brand"> Elite site Optimizer</span>
                                        </a>
                                    </p>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <div className="footer-right">
                                    <p>{/* Add content if needed */}</p>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <div className="cnt_audit_outer_wrap">
                    <div >
                        {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
                    </div>
                </div>

                <Dialog
                    open={modalIsOpen}
                    onClose={closeModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className="competitor_test_filter job_date_filter keyword_edit_form"
                >
                    <DialogTitle className="keyword-dialog-header">{isFetchedData ? 'Update ' : 'Create '}Security Audit Settings</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            <form className="frm_container" style={{ overflowY: 'auto', maxHeight: '15rem', overflowX: 'hidden', padding: '5px' }}>
                                <div className="campaigns-addedit-row">
                                    <div className="keyword-col1-fields">
                                        <div>
                                            <label>
                                                Domain URL :
                                            </label>
                                            <input
                                                title="Domain URL"
                                                type="text"
                                                name="gitrepo"
                                                value={domainUrl}
                                                onChange={onDomainUrl}
                                                placeholder="Optional..."
                                                style={{ display: "block" }}
                                            />
                                        </div>
                                        <div>
                                            <span className="error-value">{domainurlError}</span>
                                        </div>
                                    </div>
                                    <div className="keyword-col2-fields">
                                        <div>
                                            <label>
                                                Docker Hub URL :
                                            </label>
                                            <input
                                                type="text"
                                                title="Docker Hub URL"
                                                name="dockerhub"
                                                value={dockerHub}
                                                onChange={onDockerHub}
                                                placeholder="Optional..."
                                                style={{ display: "block" }} />
                                        </div>
                                        <div>
                                            {" "}
                                            <span className="error-value">{dockerHubError}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="campaigns-addedit-row">
                                    <div className="keyword-col1-fields">
                                        <div>
                                            <label>
                                                Weekly Report :
                                            </label>
                                            <Select
                                                name="weekreport"
                                                value={selectedWeekReport}
                                                options={weekReportOptions}
                                                onChange={(e) => { setWeekReport(e) }}
                                                placeholder="Select Engine"
                                                styles={customDropdownStyles()}
                                                menuPortalTarget={document.body}
                                                className=""
                                                classNamePrefix="addkeyword"
                                            />
                                        </div>
                                        <div>
                                            <span className="error-value">{weekReportError}</span>
                                        </div>
                                    </div>
                                    <div className="keyword-col2-fields">
                                        <div>
                                            <label>
                                                Git Type :
                                            </label>
                                            <div style={{ display: "flex", marginTop: "10px" }}>
                                                <div className="websitetype_inner">
                                                    <input
                                                        type="radio"
                                                        id="yes"
                                                        name="secureType"
                                                        value="public"
                                                        checked={secureType === "public"}
                                                        onChange={onOptionChange}
                                                    />
                                                    <label htmlFor="public">Public</label>
                                                </div>
                                                <div className="websitetype_inner">
                                                    <input
                                                        type="radio"
                                                        id="no"
                                                        name="secureType"
                                                        value="private"
                                                        checked={secureType === "private"}
                                                        onChange={onOptionChange}
                                                    />
                                                    <label htmlFor="private">Private</label>
                                                </div>
                                                <div className="websitetype_inner">
                                                    <input
                                                        type="radio"
                                                        id="none"
                                                        name="secureType"
                                                        value="none"
                                                        checked={secureType === "none"}
                                                        onChange={onOptionChange}
                                                    />
                                                    <label htmlFor="none">None</label>
                                                </div>
                                            </div>
                                            <div>
                                                <span className="error-value">{secureTypeError}</span>
                                            </div>
                                        </div>
                                        <div>
                                        </div>
                                    </div>
                                </div>
                                {secureType === "private" &&
                                    <>
                                        <div className="campaigns-addedit-row">
                                            <div className="keyword-col1-fields">
                                                <div>
                                                    <label>
                                                        Username :
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="textField"
                                                        title="Username"
                                                        value={onUsername}
                                                        autoComplete="no"
                                                        onChange={onDomainUrlChange}
                                                    />
                                                </div>
                                                <div>
                                                    <span className="error-value">{onUserError}</span>
                                                </div>
                                            </div>
                                            <div className="keyword-col2-fields">
                                                <div>
                                                    <label>
                                                        Password :
                                                    </label>
                                                    <FormControl variant="outlined" fullWidth>
                                                        <OutlinedInput
                                                            id="outlined-adornment-password"
                                                            type={showPassword ? 'text' : 'password'}
                                                            value={onPassword}
                                                            onChange={onpasswordChange}
                                                            className="domain-password"
                                                            autoComplete={false}
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label={showPassword ? 'hide the password' : 'display the password'}
                                                                        onClick={handleClickShowPassword}
                                                                        onMouseDown={handleMouseDownPassword}
                                                                        onMouseUp={handleMouseUpPassword}
                                                                        edge="end"
                                                                    >
                                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }
                                                        />
                                                    </FormControl>

                                                </div>
                                                <div>
                                                    {" "}
                                                    <span className="error-value">{onPasswordError}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                                {secureType !== 'none' &&
                                    <div className="campaigns-addedit-row">
                                        <div className="keyword-col1-fields">
                                            <div>
                                                <label>
                                                    Git Repository URL :
                                                </label>
                                                <input
                                                    title="Git Repository."
                                                    type="text"
                                                    name="gitrepo"
                                                    value={gitRepo}
                                                    onChange={onGitRepo}
                                                    placeholder="Optional..."
                                                    style={{ display: "block" }}
                                                />
                                            </div>
                                            <div>
                                                <span className="error-value">{gitRepoError}</span>
                                            </div>
                                        </div>
                                        <div className="keyword-col2-fields">
                                            <div>
                                                {" "}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </form>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions className="dialog-action-button">
                        <div className="dialog_box_btn " style={{ textAlign: 'center' }}>
                            <button
                                className="keyword-cancel"
                                type="button"
                                onClick={finalreportNow}
                            >
                                {isFetchedData ? 'Update ' : 'Submit '}
                            </button>
                            <button
                                className="keyword-cancel"
                                type="button"
                                onClick={closeModal}
                            >
                                Cancel
                            </button>
                            {/* <button
                                className="keyword-cancel"
                                type="button"
                                onClick={handleReset}
                            >
                                Reset
                            </button> */}
                        </div>
                    </DialogActions>
                </Dialog>

                <CommonErrorAlert
                    data={{
                        apiopen: apiopen,
                        apiErrorMsg: apierrorMsg,
                        isIconStyled: true
                    }}
                    closeAlert={apihandleClose}
                />

                <CommonErrorAlert
                    data={{
                        apiopen: successApiOpen,
                        apiErrorMsg: successApiMsg,
                        isIconStyled: false
                    }}
                    closeAlert={successPopupClose}
                />
                <UserActivityTracker pagename="Settings - Security Audit Settings" />
            </div >
        </>
    )
}

export default SecurityAuditSettings;


